module.exports = __webpack_public_path__ + "img/operagx.143db8c9.gif";